import AuthenticatedController from './AuthenticatedController';
import { PARTNERS } from '@mm/api-routes';

export default class PartnersController extends AuthenticatedController {
  static createToken(facebookPageId: number) {
    return super.post(PARTNERS, { facebook_page_id: facebookPageId });
  }

  static applyToken(companyId: number, token: string) {
    return super.put(`${PARTNERS}/apply`, { company_id: companyId, token });
  }

  static revokeToken(companyId: number, facebookPageId: number) {
    return super.delete(`${PARTNERS}/revoke`, {
      company_id: companyId,
      facebook_page_id: facebookPageId,
    });
  }

  static checkToken(token: string) {
    return super.get(`${PARTNERS}/check`, { token });
  }
}
